import { render, staticRenderFns } from "./PageTabsContent.vue?vue&type=template&id=244b4b8a&"
import script from "./PageTabsContent.vue?vue&type=script&lang=js&"
export * from "./PageTabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports